// extracted by mini-css-extract-plugin
module.exports = {"itemComplementaryInfo":"ComplementaryInfo_itemComplementaryInfo__15iKP","itemTitle":"ComplementaryInfo_itemTitle__2o69p","itemText":"ComplementaryInfo_itemText__2wme7"};